import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import {
  CreateSubDTO,
  ManagementApiService,
} from 'features/management-report/api/management-api.service';
import { queryClient } from 'providers';

import { ManagemntQueryKeys } from './query-keys';

const { createSubscription } = ManagementApiService();

export const useCreateSubscription = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: CreateSubDTO) => {
      return createSubscription(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ManagemntQueryKeys.all,
        });
      },
    },
  );
};
